import React from "react";
import { CONFIG } from "../const/config";
import PortfolioSpecs from "./PortfolioSpecs";
import Cta from "../common/Cta";

const portfolioConfig = CONFIG.portfolio;

const PortfolioItem = ({ details, id }) => {
  const htmlId = `client-work-${id}`;

  const setColumnOrder = (col) => {
    if (id % 2 === 0 && col === "image") {
      return "order-2";
    } else {
      return "order-1";
    }
  };

  return (
    <div
      className="row justify-content-around mt--2 portfolio-item"
      id={htmlId}
    >
      <div
        className={`col-lg-8 col-md-12 text-center ${setColumnOrder("image")}`}
      >
        <img alt="" src={CONFIG.projectBasePath + details.image} />
      </div>
      <div className={`col-lg-4 col-md-12 ${setColumnOrder("details")}`}>
        <div className="text-left">
          <h3>{details.title}</h3>
          {details.specs.map((spec, i) => (
            <PortfolioSpecs
              name={spec.name}
              info={spec.info}
              key={`${id} ${spec.name}`}
            />
          ))}

          <p className="lead mt--1">{details.description}</p>
          {details.links.map((link) =>
            link.name === "view" ? (
              <Cta
                link={link.url}
                label={link.label}
                type={`outline-primary`}
                icon={`after`}
                key={`${htmlId} ${link.label}`}
                classes={`view-btn`}
                newWindow={true}
              >
                <i className={`stack-right-open-big after`}></i>
              </Cta>
            ) : (
              <Cta
                link={link.url}
                label={link.label}
                type={`primary`}
                key={`${htmlId} ${link.label}`}
                newWindow={true}
              >
                {link.icon ? <i className={link.icon}></i> : null}
              </Cta>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioItem;
